import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/breadcrumb";
import React from "react";
import { Link } from "react-router-dom";
import { Events } from "../../components/Events/Events";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { useBusinessContext } from "../../context/ModelContext";
import { useUserContext } from "../../context/UserContext";

export const EventList = () => {
  const { userBusinessId } = useUserContext();
  const business = useBusinessContext();

  return (
    <>
      <PageHeading>
        <Breadcrumb>
          {!userBusinessId && (
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/businesses">
                Businesses
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to={`/businesses/${business.BusinessId}`}>
              {business.DisplayName}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
        <PageHeading.Title>Events</PageHeading.Title>
      </PageHeading>
      <PageContent padding={"10px 0 0 0"} background={"white"}>
        {<Events businessId={business.BusinessId} />}
      </PageContent>
    </>
  );
};
